<div class="body-wrapper">
  <div kendoDialogContainer></div>
  <div kendoWindowContainer></div>
  <ngx-spinner size="large"
               template="<div class='app-loading'><div class='logo'></div><svg class='spinner' viewBox='25 25 50 50'><circle class='path' cx='50' cy='50' r='20' fill='none' stroke-[width]='2' stroke-miterlimit='10' /></svg></div><div class='app-loading-text'></div>">
  </ngx-spinner>
  <app-notifier-box [(visible)]="showNotify" [dimension]="{ width: 400, height: 200 }"></app-notifier-box>

  <div id="app-kendo-overlay" class="k-overlay d-none">
    <button (click)="showNotifyToggle()" class="float-right btn btn-secondary m-2">
      <app-notifier-counter></app-notifier-counter>
    </button>
  </div>

  <c-header class="c-header" sidebarId="sidebar">
    <c-header-brand fixed="true">
      <button [cSidebarToggle]="sidebarId()" class="c-header-toggler btn">
        <i class="fa-solid fa-bars"></i>
      </button>
      <!-- Logo principale -->
      <img (click)="gotoHomePage()" src="assets/img/brandlogo.png" height="40" alt="App Logo" class="mr-2" />
    </c-header-brand>
    <div *ngIf="showEnvironment && environment != null" class="d-flex selected-environment">
      <div>
        <span kendoTooltip title="{{'Ambiente selezionato'|translate}}: {{ environment | translate }}"
              [ngStyle]="{ 'background-color': environmentColor }" class="badge-environment">
          {{ environment | translate }}
        </span>
      </div>
    </div>
    <!-- Navbar -->
    <div class="nav navbar-nav ml-auto d-flex align-items-center">
      <!-- Fullscreen toggle -->
      <div class="nav-item">
        <button class="nav-link full-screen-toggle" role="button" [ngClass]="{'full-screen' : isFullScreen}">
          <i title="{{ (isFullScreen ? 'WORD.SCREEN.COMPRESS' : 'WORD.SCREEN.FULLSCREEN') | translate }}" class="fas"
             [ngClass]="{'fa-expand' : !isFullScreen, 'fa-compress' : isFullScreen}"></i>
        </button>
      </div>
      <div class="nav-item dropdown" placement="bottom right">
        <button (click)="showNotifyToggle()" class="nav-link" tabindex="0">
          <app-notifier-counter style="width:150px"></app-notifier-counter>
        </button>
      </div>
      <app-language-selection *ngIf="useLanguageSelector"></app-language-selection>
      <div *ngIf="user" class="nav-item dropdown mr-3 flex-1 text-center" dropdown placement="bottom right">
        <a class="nav-link " data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false"
           dropdownToggle kendoTooltip position="left" (click)="false" [ngClass]="{'text-info': user.isImpersonated}"
           [title]="userTitle">
          <img *ngIf="user.avatar" src="tobedefined" class="img-avatar mr-1" alt="User Avatar" />
          <i *ngIf="!user.avatar" class="fas fa-lg"
             [ngClass]="{'fa-user-secret': user.isImpersonated, 'fa-user-shield text-info': user.asNoFilter, 'fa-user-circle': !user.isImpersonated&&!user.asNoFilter }"></i>
          <span class="ml-2 nav-link-username">{{ user.username | uppercase}}</span>
          <small class="d-none d-md-block" *ngIf="user?.fullname !== user?.username">{{user.fullname}}</small>
          <img *ngIf="user.azureLogin"
               src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Microsoft_Azure.svg/2048px-Microsoft_Azure.svg.png"
               style="height: 20px;margin-left: 10px;vertical-align: bottom;" alt="Microsoft Azure Logo" />
        </a>
        <div class="dropdown-menu dropdown-menu-right position-absolute" *dropdownMenu aria-labelledby="simple-dropdown">
          <a class="dropdown-item" [routerLink]="profileEditUrl" [app-has-state-permission]="profileEditUrl">
            <i class="fas fa-passport"></i> {{ 'WORD.USERPROFILE' | translate }}
          </a>
          <a *ngIf="!user.azureLogin" class="dropdown-item password-change" tabindex="0" (click)="changePassword()"
             (keydown)="changePassword()">
            <i class="fas fa-key"></i> {{ 'LOGIN.PASSWORDCHANGE' | translate }}
          </a>
          <hr class="m-1" />
          <a class="dropdown-item" (click)="appInfo()" (keydown.enter)="appInfo()" tabindex="1">
            <i class="fas fa-code"></i> {{ 'WORD.APPINFO' | translate }}
          </a>
          <hr class="m-1" *ngIf="policy?.length" />
          <a *ngFor="let pol of policy; let last = last;" class="dropdown-item" href="{{pol.url}}" target="_blank"
             title="{{pol.title??''|translate}}">
            {{pol.label|translate }}
          </a>
          <hr class="m-1" *ngIf="user.lastLogin" />
          <a class="dropdown-item" style="cursor:default;" tabindex="2" title="{{'PROFILE.LAST_LOGIN'|translate}}" *ngIf="user.lastLogin">
            <i class="fas fa-sign-in-alt text-info"></i> {{ user.lastLogin | date:'medium' }}
          </a>
          <hr class="m-1" />
          <a class="dropdown-item" (click)="logout()" (keydown.enter)="logout()" tabindex="3">
            <i class="fas fa-sign-out-alt text-danger"></i> {{ 'WORD.LOGOUT' | translate }}
          </a>
        </div>
      </div>
    </div>
  </c-header>

  <div class="body-content">
    <c-sidebar class="c-sidebar" [visible]="sideBarVisible" [colorScheme]="'dark'" id="sidebar" [placement]="'start'" [size]="'xl'" [overlaid]="true" (click)="onItemClick($event)">
      <ng-scrollbar pointerEventsMethod="scrollbar" visibility="hover">
        <c-sidebar-nav [navItems]="navItems" [dropdownMode]="'none'" [compact]="true" [role]="'navigation'"></c-sidebar-nav>
      </ng-scrollbar>
    </c-sidebar>

    <div class="app-body">
      <!-- Main content -->
      <main class="main">
        <!-- Breadcrumb -->
        <div class="breadcrumb-div d-flex-center p-2">
          <ol class="breadcrumb">
            <app-custom-breadcrumb></app-custom-breadcrumb>
          </ol>
        </div>
        <ng-scrollbar pointerEventsMethod="scrollbar" visibility="hover">
          <div class="container-fluid p-3">
            <alert *ngIf="alert?.message != null" [type]="alert?.type??''" [dismissible]="alert?.dismissible??true"
                   (onClosed)="onAlertClosed($event)" class="d-block mb-3">
              <div [innerHtml]="alert?.message??''|safeHtml"></div>
            </alert>
            <router-outlet></router-outlet>
          </div>
        </ng-scrollbar>
      </main>
    </div>
  </div>
  <c-footer>
    <span class="flex-1">
      <a style="height: 30px;" href="http://resdata.it/" target="_blank" title="Res Data | &copy;{{year}}">
        <img style="height: inherit;" alt="Res Data | &copy;{{year}}" src="assets/img/logo-resdata.png" />
      </a>
    </span>
    <span class="ml-auto fw-bold"><b>{{applicationName}}</b></span>
    <span class="ml-1">
      <button class="btn btn-outline-dark" style="border:none;"
              (click)="uiInfo()">
        v.{{appVersion}}
      </button>
    </span>
  </c-footer>
</div>
